/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import AssetModel from 'cio/models/asset';
import ClipboardJS from 'clipboard';

interface AssetLibraryItemControlsArgs {
  asset: AssetModel;
  onCopy?: (asset: AssetModel) => unknown;
  onPreview?: (asset: AssetModel) => unknown;
  onDelete?: (asset: AssetModel) => unknown;
}

export default class AssetLibraryItemControls extends Component<AssetLibraryItemControlsArgs> {
  @service auth!: AuthService;

  @tracked clipboard: ClipboardJS | null = null;

  get canDelete() {
    return this.auth.hasPermission('journeys/assets/delete');
  }

  @computed('args.asset.size')
  get isDeletableAsset() {
    if (!this.canDelete) {
      return false;
    }

    return this.args.asset.isDeletable;
  }

  @action
  onCopy(e: MouseEvent) {
    e.stopPropagation();

    this.args.onCopy?.(this.args.asset);
  }

  @action
  onPreview(e: MouseEvent) {
    e.stopPropagation();

    this.args.onPreview?.(this.args.asset);
  }

  @action
  onDelete(e: MouseEvent) {
    e.stopPropagation();

    this.args.onDelete?.(this.args.asset);
  }
}
